var counter = 0;
var tplNameMap = new Map();
export function getViewTplName(name, rootId) {
  return "".concat(getViewTplNamePrefixByRootId(rootId)).concat(getViewTplNameSuffix(name));
}
export function getAppTplName(name) {
  return "tpl".concat(getViewTplNameSuffix(name));
}
function getViewTplNamePrefixByRootId(rootId) {
  if (!tplNameMap.has(rootId)) {
    tplNameMap.set(rootId, "isolated-tpl-".concat(counter++));
  }
  return tplNameMap.get(rootId);
}
function getViewTplNameSuffix(name) {
  return name.replace(/([A-Z])/g, "-$1").toLowerCase();
}
//# sourceMappingURL=getTplName.js.map